import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
    standalone: true,
    imports: [CommonModule, PlatformModule, TranslateModule],
    template: `
        <div class="flex">
            {{ params.displayName }}
            <ui-info class="margin-left-1" tooltipPosition="below" text="{{ this.params.tooltip }}"> </ui-info>
        </div>
    `,
})
export class CustomHeader implements IHeaderAngularComp {
    public params!: { tooltip: string } & IHeaderParams;
    agInit(params: { tooltip: string } & IHeaderParams): void {
        this.params = params;
    }

    refresh(params: IHeaderParams) {
        return false;
    }
}
